import { ExportTypeEnum, CodeBook } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

const educationSectorUrlPrefix: string = "education-sectors";

export const exportEducationSectors = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${educationSectorUrlPrefix}/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

export const exportEducationSubSectors = async (exportType: ExportTypeEnum) => {
  var result = await (api.download(
    `${educationSectorUrlPrefix}/education-sub-sectors/export/${exportType}`,
    "get"
  ) as Promise<unknown>);
  return result
}

export const searchEducationSectors = async (search: string) => {
  let request: any = {search: search}
  let url = `${educationSectorUrlPrefix}/search?search=${search}`;
  return api.get(url, request) as Promise<CodeBook[]>;
}